module.exports = __webpack_public_path__ + "img/carousel-clientes-10.7ab0b610.png";